// extracted by mini-css-extract-plugin
export default {"wrapper":"Gp-z","response":"Hp-z","error":"Ip-z","disabled":"Jp-z","buttons":"Kp-z","feedbackQuestionSection":"Lp-z","yesNoWrapper":"Mp-z"};